export const CONSTANTS = {
  features: [
    {
      text: "Proactively detect and resolve network performance issues.",
    },
    {
      text: "Gain real-time, AI-driven network visibility across cloud and hybrid environments.",
    },
    {
      text: "Enhance security with continuous monitoring and automated threat detection.",
    },
    {
      text: "Ensure compliance with industry standards and best practices.",
    },
  ],
  title: "Why choose OneMind for Network observability & NMS?",
  description: [
    "OneMind Services delivers advanced network observability and monitoring solutions that empower businesses to:",
  ],
  extraContent:
    "With OneMind Services, businesses reduce downtime, optimize network performance, and strengthen security with cutting-edge observability and NMS solutions.",
};
